import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { DisplayConditionTypeComponents } from '../../../shared/domain/display.condition.type';

@Component({
  selector: 'cc-item',
  templateUrl: './item.component.html',
  styleUrls: ['./item.component.scss']
})
export class ItemComponent implements OnInit {
  @Input() displayConditionForm: FormGroup;
  public displayComponents: { firstComponent: any; secondComponent: any; inputs: any };
  private dynamicInputs: { form: FormGroup };

  constructor() {}

  ngOnInit() {
    this.setDisplayComponents();
    this.displayConditionForm.get('type').valueChanges.subscribe(() => this.setDisplayComponents());
  }

  setDisplayComponents() {
    this.displayComponents = DisplayConditionTypeComponents[this.displayConditionForm.get('type').value];
    this.dynamicInputs = {
      form: this.displayConditionForm,
      ...this.displayComponents.inputs
    };
  }
}
